import { capFirstChar, kelvin_to_rgb } from '../../../../helpers/utilities';
import { dev_action_to_label_list, grp_action_to_label_list } from './actions_to_label_list';

import { COMMAND_TO_I18N_ACTION_MSG } from './actions_to_i18n';
import { _init_notifications } from '../../helpers/init_notification_actions';
import { format } from 'svelte-i18n';
import { get } from 'svelte/store';
import { devices } from 'src/stores/lists/devices';
import { get_vc_action_label } from '../../helpers/virtual_components/virtual_device_preview';
import { isXT1Module } from 'src/helpers/xt1_helpers/template_helpers';
import { xt1_action_to_label_list } from '../../helpers/virtual_components/xt1_device_scenes_helpers';
import { isCctOnlyDevice } from 'src/helpers/interface_helpers';

let _format = get(format);
export function _device_action_msg(category, translated, gen, device_id, mode) {
	const { actions, delay, timer } = translated;
	if (!actions || actions.length === 0) return;
	let subtitle = '',
		labelList = [],
		conditionList = [],
		background;

	// Ivo: This logic can be changed in the future, for now this is how we get the label list for a missing device
	if (!category) {
		const channel = device_id.substring(device_id.indexOf('_') + 1);
		const isVirtualDevice = channel > 200;
		const { name, value } = actions[0];

		if (translated?.actions?.[0] && isVirtualDevice) {
			labelList.push(get_vc_action_label(translated));
		} else if (name && value) {
			subtitle = COMMAND_TO_I18N_ACTION_MSG(actions[0], gen, device_id);
			labelList.push(dev_action_to_label_list(actions[0], device_id));
		} else if (
			actions.find((el) => el.name === 'r')?.value &&
			actions.find((el) => el.name === 'g')?.value &&
			actions.find((el) => el.name === 'b')?.value
		) {
			let set_lights = [];
			let turn = actions.find((el) => el.name === 'turn' || el.name === 'state');
			let rgb = {
				r: actions.find((el) => el.name === 'r')?.value,
				g: actions.find((el) => el.name === 'g')?.value,
				b: actions.find((el) => el.name === 'b')?.value,
			};

			let brightness = actions.find((el) => el.name === 'brightness' || el.name === 'gain');

			let white_channel = actions.find((el) => el.name === 'white_channel');
			let color_temp = actions.find((el) => el.name === 'temp' || el.name === 'ct');
			let transition_duration = actions.find((el) => el.name === 'transition_duration');

			if (turn) {
				set_lights.push(COMMAND_TO_I18N_ACTION_MSG(turn, gen, device_id));
				labelList.push(dev_action_to_label_list(turn, device_id));
			}

			if (brightness) {
				set_lights.push(COMMAND_TO_I18N_ACTION_MSG(brightness, gen, device_id));
				labelList.push(dev_action_to_label_list(brightness, device_id));
			}

			if (white_channel) {
				set_lights.push(COMMAND_TO_I18N_ACTION_MSG(white_channel, gen, device_id));
				labelList.push(dev_action_to_label_list(white_channel, device_id));
			}

			if (rgb.r !== undefined && !color_temp) {
				background = `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`;
				/**
				 * Todo: THINK how to handle it for i18n and label
				 */
				labelList.push({
					name: 'gain',
					icon: 'fa-duotone fa-light fa-circle',
					iconStyle: `--fa-primary-color: var(--color-white); --fa-secondary-color: ${background}; --fa-secondary-opacity: 1`,
				});
			}

			if (color_temp) {
				set_lights.push(COMMAND_TO_I18N_ACTION_MSG(color_temp, gen, device_id));
				labelList.push({
					icon: 'fa fa-circle',
					name: 'color_temp',
					value: `${color_temp.value} K`,
				});
			}

			if (transition_duration) {
				set_lights.push(COMMAND_TO_I18N_ACTION_MSG(transition_duration, gen, device_id));
				labelList.push(dev_action_to_label_list(transition_duration, device_id));
			}

			subtitle = set_lights.join(', ');
		} else {
			subtitle = _format('scenes_title_unknown_action', {
				default: 'Unknown action',
			});
		}
	}

	switch (category) {
		case 'pv':
			const output_limit = actions.find((el) => el.name === 'outputLimit');
			if (output_limit) {
				subtitle = COMMAND_TO_I18N_ACTION_MSG(output_limit, gen, device_id);
				labelList.push(dev_action_to_label_list(output_limit, device_id));
			}
			break;
		case 'virtual_device':
			labelList.push(get_vc_action_label(translated));
			break;
		case 'relay':
		case 'emeter':
		case 'roller':
		case 'breaker':
		case 'lock':
		case 'sensor':
			subtitle = COMMAND_TO_I18N_ACTION_MSG(actions[0], gen, device_id);
			labelList.push(dev_action_to_label_list(actions[0], device_id));
			break;

		case 'module':
			if (mode === 'output_reader' || mode === 'relay') {
				subtitle = COMMAND_TO_I18N_ACTION_MSG(actions[0], gen, device_id);
				labelList.push(dev_action_to_label_list(actions[0], device_id));
			} else if (mode === 'cct' || isCctOnlyDevice(get(devices)[device_id]?.type)) {
				let set_lights = [];
				let turn = actions.find((el) => el.name === 'turn' || el.name === 'state');
				let brightness = actions.find((el) => el.name === 'brightness' || el.name === 'gain');
				let color_temp = actions.find((el) => el.name === 'temp' || el.name === 'ct');
				let transition_duration = actions.find((el) => el.name === 'transition_duration');

				if (turn) {
					set_lights.push(COMMAND_TO_I18N_ACTION_MSG(turn, gen, device_id));
					labelList.push(dev_action_to_label_list(turn, device_id));
				}

				if (brightness) {
					set_lights.push(COMMAND_TO_I18N_ACTION_MSG(brightness, gen, device_id));
					labelList.push(dev_action_to_label_list(brightness, device_id));
				}

				if (color_temp) {
					set_lights.push(COMMAND_TO_I18N_ACTION_MSG(color_temp, gen, device_id));
					labelList.push({
						icon: 'fa-duotone fa-light fa-circle',
						name: 'color_temp',
						value: `${color_temp.value} K`,
						iconStyle: `--fa-primary-color: var(--color-white); --fa-secondary-color: rgb(${kelvin_to_rgb(color_temp.value)[0]}, ${kelvin_to_rgb(color_temp.value)[1]}, ${kelvin_to_rgb(color_temp.value)[2]}); --fa-secondary-opacity: 1`,
					});
				}

				if (transition_duration) {
					set_lights.push(COMMAND_TO_I18N_ACTION_MSG(transition_duration, gen, device_id));
					labelList.push(dev_action_to_label_list(transition_duration, device_id));
				}

				subtitle = set_lights.join(', ');
			}
			break;

		case 'light':
			let set_lights = [];
			let turn = actions.find((el) => el.name === 'turn' || el.name === 'state');
			let rgb = {
				r: actions.find((el) => el.name === 'r')?.value,
				g: actions.find((el) => el.name === 'g')?.value,
				b: actions.find((el) => el.name === 'b')?.value,
			};

			let brightness = actions.find((el) => el.name === 'brightness' || el.name === 'gain');

			let white_channel = actions.find((el) => el.name === 'white_channel');
			let color_temp = actions.find((el) => el.name === 'temp' || el.name === 'ct');
			let transition_duration = actions.find((el) => el.name === 'transition_duration');

			if (turn) {
				set_lights.push(COMMAND_TO_I18N_ACTION_MSG(turn, gen, device_id));
				labelList.push(dev_action_to_label_list(turn, device_id));
			}

			if (brightness) {
				set_lights.push(COMMAND_TO_I18N_ACTION_MSG(brightness, gen, device_id));
				labelList.push(dev_action_to_label_list(brightness, device_id));
			}

			if (white_channel) {
				set_lights.push(COMMAND_TO_I18N_ACTION_MSG(white_channel, gen, device_id));
				labelList.push(dev_action_to_label_list(white_channel, device_id));
			}

			if (rgb.r !== undefined && !color_temp) {
				background = `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`;
				/**
				 * Todo: THINK how to handle it for i18n and label
				 */
				labelList.push({
					name: 'gain',
					icon: 'fa-duotone fa-light fa-circle',
					iconStyle: `--fa-primary-color: var(--color-white); --fa-secondary-color: ${background}; --fa-secondary-opacity: 1`,
				});
			}

			if (color_temp) {
				const color_temp_value = kelvin_to_rgb(color_temp.value);
				set_lights.push(COMMAND_TO_I18N_ACTION_MSG(color_temp, gen, device_id));

				labelList.push({
					icon: 'fa-duotone fa-light fa-circle',
					name: 'color_temp',
					value: color_temp.value,
					iconStyle: `--fa-primary-color: var(--color-white); --fa-secondary-color: rgb(${color_temp_value[0]}, ${color_temp_value[1]}, ${color_temp_value[2]}); --fa-secondary-opacity: 1`,
				});
			}

			if (transition_duration) {
				set_lights.push(COMMAND_TO_I18N_ACTION_MSG(transition_duration, gen, device_id));
				labelList.push(dev_action_to_label_list(transition_duration, device_id));
			}

			subtitle = set_lights.join(', ');

			break;

		case 'thermostat':
			subtitle = COMMAND_TO_I18N_ACTION_MSG(actions[0], gen, device_id);
			labelList.push(dev_action_to_label_list(actions[0], device_id));
			break;
		case 'media_player':
			subtitle = COMMAND_TO_I18N_ACTION_MSG(actions[0], gen, device_id);
			labelList.push(dev_action_to_label_list(actions[0], device_id));
			//Todo need to add translations
			break;
		case 'diffuser':
			subtitle = COMMAND_TO_I18N_ACTION_MSG(actions[0], gen, device_id);
			labelList.push(dev_action_to_label_list(actions[0], device_id));
			break;
		case 'camera':
			subtitle = COMMAND_TO_I18N_ACTION_MSG(actions[0], gen, device_id);
			labelList.push(dev_action_to_label_list(actions[0], device_id));
			break;
		case 'fan':
			subtitle = actions
				.map((action) => COMMAND_TO_I18N_ACTION_MSG(action, gen, device_id))
				.join(', ');
			actions.forEach((action) => {
				labelList.push(dev_action_to_label_list(action, device_id));
			});
			break;
		default:
			subtitle = _format('scenes_title_unknown_action', {
				default: 'Unknown action',
			});
			break;
	}

	if (actions?.[0] && isXT1Module(get(devices)[device_id]?.type)) {
		labelList.push(xt1_action_to_label_list(translated));
	}

	const actionList = handle_action_timer_delay(timer, delay);

	return {
		subtitle: capFirstChar(subtitle),
		labelList,
		conditionList,
		actionList,
	};
}

export function _notification_action_msg(_msg, msgType, delay, timer) {
	const subtitle = !_msg || _msg === '' ? _msg : `"${_msg}"`;

	const actionList = handle_action_timer_delay(timer, delay);

	return { subtitle, actionList };
}

export function findIconAndTitle(id) {
	return {
		icon: _init_notifications[id]?.props?.icon || undefined,
		title: _init_notifications[id]?.title,
	};
}

export function _group_action_msg(group_type, actions, timer, delay) {
	let labelList = [],
		subtitle = '';

	switch (group_type) {
		case 'relay':
		case 'light':
			subtitle = 'Turn ' + actions[0].value;
			labelList.push(grp_action_to_label_list(actions[0]));
			break;
		case 'roller':
			subtitle = 'Direction ' + actions[0].value;
			labelList.push(grp_action_to_label_list(actions[0]));
			break;
		default:
			break;
	}

	const actionList = handle_action_timer_delay(timer, delay);

	return { labelList, subtitle, actionList };
}

export const handle_action_timer_delay = (timer, delay) => {
	const actionList = [];

	if (timer !== undefined && timer.value > 0) {
		actionList.push({
			icon: 'fa-solid fa-stopwatch',
			name: get(format)('action_timer_message', {
				values: {
					value: timer.value,
					units: get(format)(`action_delay_message_units_${timer.units}`, {
						default: `${timer.units}`,
					}),
				},
				default: 'Timer {value} {units}',
			}),
			type: 'timer',
		});
	}

	if (delay !== undefined) {
		actionList.push({
			icon: 'fa-solid fa-hourglass-clock',
			name: get(format)('action_delay_message', {
				values: {
					value: delay.value,
					units: get(format)(`action_delay_message_units_${delay.units}`, {
						default: `${delay.units}`,
					}),
				},
				default: 'Delay {value} {units}',
			}),
			type: 'delay',
		});
	}

	return actionList;
};
